import styled from 'styled-components';
import { fontTitle, fontBody } from 'Styles/fonts';

import { CardContent as CardContentOriginal } from '../../../Card/Card';

export const CardContent = styled(CardContentOriginal)`
  display: flex;
  flex-direction: row;
`;

export const CopyContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Title = styled.h1`
  ${fontTitle(18)};
  color: var(--foreground);
  margin: 0;
  margin-bottom: 4px;
`;

export const Description = styled.p`
  ${fontBody(14)};
  color: var(--ring);
  margin: 0;
`;

export const IconContainer = styled.div`
  color: var(--foreground);
  display: flex;
  align-items: center;
  width: 40px;
  justify-content: center;
`;
